import { IBusiness, ICreateBusinessRequest, IDeleteBusinessRequest, IUpdateBusinessRequest } from '@core/models';

export class CreateBusiness {
  static readonly type = '[Business] Create Business';
  static readonly desc = 'Create Business';

  constructor(public payload: ICreateBusinessRequest) {}
}

export class GetBusinesses {
  static readonly type = '[Businesses] GET Businesses';
  static readonly desc = 'Get Businesses From GQL';

  constructor() {}
}

export class UpdateBusiness {
  static readonly type = '[Business] Update Business';
  static readonly desc = 'Update Business';

  constructor(public payload: IUpdateBusinessRequest) {}
}

export class UpdateBusinessFromServer {
  static readonly type = '[Business] Update Business From Server';
  static readonly desc = 'Update Business From Server';

  constructor() {}
}

export class DeleteBusiness {
  static readonly type = '[Business] Delete Business';
  static readonly desc = 'Delete Business';

  constructor(public payload: IDeleteBusinessRequest) {}
}

export class SetSelectedBusiness {
  static readonly type = '[Business] Set Selected Business';
  static readonly desc = 'Set Selected Business';

  constructor(public payload: IBusiness | null) {}
}

// Dummy class for flag AdAccount Connected event
export class AdAccountConnected {
  static readonly type = '[Business] Ad Account Connected';
  static readonly desc = 'Ad Account Connected';

  constructor() {}
}
